// src/contexts/ProfilContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { ecouterProfil, updatePseudo } from "../services/db";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../services/firebase";
import { useAuth } from "./AuthContext";
import { useTombola } from "./TombolaContext";

const ProfilContext = createContext();
export const useProfil = () => useContext(ProfilContext);

export function ProfilProvider({ children }) {
  const { currentUser, orgId } = useAuth();
  const { tombolas } = useTombola();
  const [profil, setProfil] = useState(null);

  useEffect(() => {
    if (!currentUser?.uid) return;
    const unsub = ecouterProfil(currentUser.uid, setProfil);
    return unsub;
  }, [currentUser]);

  const monPseudo = profil?.pseudo || currentUser?.email?.split("@")[0] || "—";

  // Retourne le pseudo d'un email donné (pour le rapport)
  function getPseudo(email) {
    if (!email) return "—";
    // Pour l'utilisateur courant
    if (email === currentUser?.email) return monPseudo;
    // Pour les autres, on retourne juste le début de l'email
    return email.split("@")[0];
  }

  async function savePseudo(pseudo) {
    if (!currentUser?.uid) return;
    const nouveau = pseudo.trim().slice(0, 30);
    await updatePseudo(currentUser.uid, nouveau);

    // Met à jour le prénom affiché dans l'Équipe (fiches membre de l'association active).
    // Une fiche absente (tombola dont on n'est pas membre) est simplement ignorée.
    if (!orgId) return;
    const uid = currentUser.uid;
    const fiches = [
      doc(db, "organisations", orgId, "membres", uid),
      ...tombolas.map((t) => doc(db, "organisations", orgId, "tombolas", t.id, "membres", uid)),
    ];
    await Promise.all(fiches.map((ref) => updateDoc(ref, { pseudo: nouveau }).catch(() => {})));
  }

  return (
    <ProfilContext.Provider value={{ profil, monPseudo, savePseudo, getPseudo }}>
      {children}
    </ProfilContext.Provider>
  );
}
